export const SUPPORT_WA = "966537003141";
export const waLink = (text) => `https://wa.me/${SUPPORT_WA}?text=${encodeURIComponent(text || "")}`;
export const PRICES = { semester: 199, year: 349 };
